import { EventTrackerAdapter } from '../event-tracker.adapter';
import { BrowserStore } from '@app/store/browser';

type DataLayer = typeof window & {
  push(params: unknown): void;
};

export class DataLayerAdapter implements EventTrackerAdapter {
  constructor(private browserStore: BrowserStore) {}

  initDataLayer() {
    // TODO: verify how to initialize this
    // datalayer.init(environment.DATALAYER_KEY);
  }

  async track<T extends Partial<T>>(eventName: string, _eventData?: T) {
    const datalayer = this.browserStore.getInjectedOnWindow<DataLayer>('dataLayer');

    datalayer?.push({ event: eventName });
  }
}
